export default __webpack_public_path__ + "static/media/abhfl_new_banner.34bcbca9.png";